module.exports = __webpack_public_path__ + "static/img/client2.d9578f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients/client2.jpg
// module id = 75
// module chunks = 1